<template>
  <ConfiguratorOverlay>
    <PortraitPopup />

    <MediaclipError
      v-if="configuratorStore.hasMediaclipError"
      class="col-span-full"
    />

    <template v-else-if="configuratorStore.isUploadConfigurator">
      <div class="relative col-start-1 h-full lg:col-end-3">
        <div class="relative flex h-full flex-col items-center justify-center">
          <div ref="configurator" class="w-full grow" />

          <DefaultButton
            class="shrink gap-3 border-t border-gray-100 bg-white p-3 md:hidden"
            @click="
              configuratorStore.isSizeSelectorOpen =
                !configuratorStore.isSizeSelectorOpen
            "
          >
            <span
              v-t="{
                path: 'pages.navigation.change_size',
                args: { size: sizeStore.selectedSizeOption.label },
              }"
              class="text-black underline"
            />

            <PencilIcon class="-my-1 block w-6 text-black md:hidden" />
          </DefaultButton>
        </div>

        <!-- Size selector pop-up -->
        <div
          :class="[
            configuratorStore.isSizeSelectorOpen
              ? 'translate-y-0'
              : 'translate-y-full',
          ]"
          class="absolute inset-0 flex h-full w-full items-end justify-center bg-white transition-transform duration-500 md:hidden"
        >
          <ConfiguratorFilters
            id="configuratorContainerMobile"
            class="mx-1 h-full w-full overflow-y-scroll px-2 pt-3"
            custom-size-radio-button-id="custom-size-radio-button-mobile"
          />
        </div>
      </div>

      <div
        id="configuratorContainerDesktop"
        class="col-start-2 hidden w-full overflow-y-auto px-4 py-4 md:block lg:col-start-3"
      >
        <ConfiguratorFilters />
      </div>
    </template>

    <div v-else ref="configurator" class="col-span-full h-full" />

    <div
      v-if="
        !configuratorStore.mediaclipLaunched &&
        !configuratorStore.isUploadConfigurator &&
        !configuratorStore.hasMediaclipError
      "
      class="col-span-auto fixed right-0 top-0 z-40 flex h-full w-full items-center justify-center"
    >
      <SpinnerIcon size="w-12 h-12" />
    </div>
  </ConfiguratorOverlay>
</template>

<script setup lang="ts">
import SpinnerIcon from '@/components/Icons/SpinnerIcon.vue';
import DefaultButton from '@/components/Buttons/DefaultButton.vue';
import MediaclipError from '@/components/States/MediaclipError.vue';
import PortraitPopup from '@/components/States/PortraitPopup.vue';
import { useMediaclipCommunication } from '@/composables/UseMediaclipCommunication';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';
import { useSizeStore } from '@/stores/Configurator/SizeStore';
import { PencilIcon } from '@heroicons/vue/20/solid';
import { onMounted, Ref, ref, watch } from 'vue';
import ConfiguratorFilters from './Filters/ConfiguratorFilters.vue';
import ConfiguratorOverlay from './ConfiguratorLayout/ConfiguratorOverlay.vue';

const configuratorStore = useConfiguratorStore();
const sizeStore = useSizeStore();
const mediaclipCommunicationComposable = useMediaclipCommunication();

const configurator = ref() as Ref<HTMLDivElement>;

onMounted(() => {
  if (
    configuratorStore.mediaclipToken &&
    configuratorStore.mediaclipProjectId
  ) {
    configuratorStore.mediaclipInitialized = true;
  }
});

watch(
  () => configuratorStore.mediaclipInitialized,
  initialized => {
    if (initialized) {
      mediaclipCommunicationComposable.launchMediaclip(configurator);
    } else {
      window.removeEventListener(
        'message',
        mediaclipCommunicationComposable.mediaclipEventListener
      );
    }
  }
);
</script>
